export const ERROR_SET = 'GroupModal/error-set';
export const GROUP_NAME_CHANGE = 'GroupModal/group-name-change';
export const GROUP_TYPE_SET = 'GroupModal/group-type-set';
export const ITEM_GROUP_APPLY = 'GroupModal/item-group-select';
export const ITEM_SELECTION_CLEAR = 'GroupModal/item-selection-clear';
export const MOVE = 'GroupModal/move';
export const OPEN = 'GroupModal/open';
export const OPEN_EDIT = 'GroupModal/open-edit';
export const SAVE_REQUEST = 'GroupModal/save-request';
export const SHOW = 'GroupModal/show';
export const STORE_GROUP_APPLY = 'GroupModal/store-group-select';
export const STORE_GROUP_APPLY_BY_SECTION = 'GroupModal/store-group-select-by-section';
export const SELECTION_CLEAR = 'GroupModal/selection-clear';
export const SET_GROUP = 'GroupModal/set-group';
export const SET_EDITING_GROUP = 'GroupModal/set-editing-group';
export const CURRENT_STEP_SET = 'GroupModal/current-step-set';
export const PREVIOUS = 'GroupModal/previous-step-set';
export const CREATE_GROUP_FINISH = 'GroupModal/create-group-finish';
export const RESET = 'GroupModal/reset_all';
